import React, { useCallback, useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { fetchUsersByType } from "../../../services/user/fetchUsersByType";
import { Pagination } from "../../../utils/Pagination";
import { CreateUser } from "../../auth/CreateUser";
import { IoAdd } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";


export const UserManage = () => {

  const { BeURL, isAuth, currentUser } = useContext(DContext);

  const [popup, setPopup] = useState(false);
  const navigate = useNavigate()

  // Tabs
  const [activeTab, setActiveTab] = useState("instructor");

  // Users
  const [users, setUsers] = useState([]);

  // Pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);

  // Load data

  // Fetch users
  const loadUsers = useCallback(async () => {

    const data = await fetchUsersByType({
      BeURL,
      type: activeTab,
      page,
      limit,
    });

    if (data?.success) {
      setUsers(data.users);
      setTotalPages(data.totalPages);
      setTotalUsers(data.total);
    }
  }, [BeURL, activeTab,page,limit]);
  
  useEffect(() => {
    loadUsers();
  }, [loadUsers]);


  const handleUser = (userId) => {
    navigate('/app/view-user', { state: { userId } });
  };

  // Tab change
  const handleTabChange = (type) => {
    setActiveTab(type);
    setPage(1); // reset page
  };

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">

      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">

        <h2 className="text-2xl font-bold text-gray-800">
          User Management
        </h2>

        {isAuth && ["superadmin", "admin"].includes(currentUser?.role) && (
          <button
            onClick={() => setPopup(true)}
            className="flex items-center gap-2 bg-primary-600 hover:bg-primary-700 font-semibold text-white px-5 py-2 rounded-lg shadow transition"
          >
            <IoAdd />

            {currentUser?.role === "superadmin"
              ? "Create Admin"
              : "Create Instructor"}
          </button>
        )}
      </div>

      {/* Tabs */}
      <div className="flex gap-3 border-b">

        <button
          onClick={() => handleTabChange("instructor")}
          className={`px-4 py-2 font-medium text-sm transition
            ${activeTab === "instructor"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500 hover:text-blue-600"
            }`}
        >
          Instructors
        </button>

        <button
          onClick={() => handleTabChange("user")}
          className={`px-4 py-2 font-medium text-sm transition
            ${activeTab === "user"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500 hover:text-blue-600"
            }`}
        >
          Users
        </button>

      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow overflow-x-auto">

        <table className="min-w-full text-sm text-left">

          <thead className="bg-primary-100 text-xs capitalize text-primary-600">
            <tr>
              <th className="px-4 py-3 font-semibold">Sl.No</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Email</th>
              <th className="px-4 py-3 font-semibold">Contact</th>
              <th className="px-4 py-3 font-semibold">Role</th>
              <th className="px-4 py-3 font-semibold text-center">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>

            {users.length === 0 ? (

              <tr>
                <td
                  colSpan="5"
                  className="text-center py-6 text-gray-500"
                >
                  No Users Found
                </td>
              </tr>

            ) : (

              users.map((user, index) => (

                <tr
                  key={user._id}
                  className="border-t hover:bg-gray-50"
                >

                  <td className="px-4 py-3">
                    {(page - 1) * limit + index + 1}
                  </td>

                  <td className="px-4 py-3">
                    {user?.fullName || "-"}
                  </td>

                  <td className="px-4 py-3">
                    {user?.email || "-"}
                  </td>

                  <td className="px-4 py-3">
                    {user?.contact || "-"}
                  </td>

                  <td className="px-4 py-3 capitalize">
                    {user.role === "user" ? "Student" : user?.role}
                  </td>
                  <td className="px-4 py-3 text-center space-x-2">
                    <button title="view" onClick={()=>handleUser(user?._id)} className="text-xs  text-primary-700 rounded ">
                      <GrView size={20}/>
                    </button>
                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

        {/* Pagination */}
        <Pagination
          page={page}
          totalPages={totalPages}
          limit={limit}
          totalUsers={totalUsers}
          setPage={setPage}
          setLimit={setLimit}
        />
      </div>

      {popup && (
        <CreateUser onClose={() => setPopup(false)} />
      )}

    </div>
  );
};


